<template>
    <div > 
        <div class="flex flex-col">
            <div class="join join-vertical mt-2 drop-shadow-lg border border-base-content/5 w-6" v-if="layers.length > 1">
                    <button
                        v-for="layer in layers" 
                        :key="'btn-layer-' + layer.id"
                        class="btn join-item"
                        :class="{ 'btn-neutral': currentLayer.id == layer.id }"
                        @click="changeLayer(layer)"
                    >
                            {{ layer.shortened_title }}
                    </button>
            </div>
        </div>
    </div>   
</template>

<script>
export default {
    props: {
        layers: {
            type: Array,
            required: true
        },
        currentLayer: {
            type: Object,
            required: true
        },
        layerTitle: {
            type: String,
            required: true
        },
        parcelTitle: {
            type: String,
            required: true
        },
        goToMainMap: {
            type: Function,
            required: true
        },
        trans: {
            type: Object,
            required: true
        }
    },
    methods: {
        changeLayer(payload) {
            this.$emit('changedLayer', payload);
        }
    }
};
</script>

<style>
</style>